<template>
    <div>
        <div class="box">
            <div ref="course" style="width:100%;height:376px"></div>
            <div class="under">
                <div style="width:200px;height: 80px;color:#fff" class="left">
                    <div style="font-size: 16px;font-weight: bold;">学生未到校情况</div>
                    <ul class="home_ul">
                        <li v-for="(item, index) in student.reason" :key="index">
                            <div class="home_ul_main">
                                <div class="home_li_tit">{{ item.reason_name }}</div>
                                <div class="home_li_num">{{ item.count }} <span>人</span></div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="zhanwei"></div>
                <div style="width:200px;height: 80px;color:#fff" class="right">
                    <div style="font-size: 16px;font-weight: bold;">教师未到校情况</div>
                    <ul class="home_ul">
                        <li v-for="(item, index) in teacher.reason" :key="index">
                            <div class="home_ul_main">
                                <div class="home_li_tit">{{ item.reason_name }}</div>
                                <div class="home_li_num">{{ item.count }}<span>人</span></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { dataBoardAttendance } from "@/api/index";
export default {
    data() {
        return {
            student: {
                actual: 0,
                total: 0,
                list: [],
                reason: [],
            },
            teacher: {
                reason: [],
            },
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        async getList() {
            const res = await this.axios.post(dataBoardAttendance);
            if (res.data.code == 1) {
                this.student = res.data.data.student;
                this.teacher = res.data.data.teacher;
                this.getCourse();
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
        getCourse() {
            const chart = this.$refs.course;
            const myChart = this.$echarts.init(chart);
            const option = {
                series: [
                    {
                        type: 'gauge',
                        center: ['50%', '60%'],
                        startAngle: 200,
                        endAngle: -20,
                        min: 0,
                        max: this.student.total,
                        splitNumber: 12,
                        itemStyle: {
                            color: '#FFAB91'
                        },
                        progress: {
                            show: true,
                            width: 30
                        },
                        pointer: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                width: 30
                            }
                        },
                        axisTick: {
                            show: false,
                            distance: -45,
                            splitNumber: 5,
                            lineStyle: {
                                width: 2,
                                color: '#999'
                            }
                        },
                        splitLine: {
                            show: false,
                            distance: -52,
                            length: 14,
                            lineStyle: {
                                width: 3,
                                color: '#999'
                            }
                        },
                        axisLabel: {
                            show: false,
                            distance: -20,
                            color: '#999',
                            fontSize: 20
                        },
                        anchor: {
                            show: false
                        },
                        title: {
                            show: false
                        },
                        detail: {
                            valueAnimation: true,
                            width: '60%',
                            lineHeight: 40,
                            borderRadius: 8,
                            offsetCenter: [0, '-15%'],
                            fontSize: 15,
                            fontWeight: 'bolder',
                            formatter: `实际到校学生人数\n${this.student.actual}\n全校学生人数：${this.student.total}`,
                            color: 'inherit'
                        },
                        data: [
                            {
                                value: this.student.actual
                            }
                        ]
                    },
                    {
                        type: 'gauge',
                        center: ['50%', '60%'],
                        startAngle: 200,
                        endAngle: -20,
                        min: 0,
                        max: this.student.total,
                        itemStyle: {
                            color: '#FD7347'
                        },
                        progress: {
                            show: true,
                            width: 8
                        },
                        pointer: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                        },
                        detail: {
                            show: false
                        },
                        data: [
                            {
                                value: this.student.actual
                            }
                        ]
                    }
                ]
            }
            option && myChart.setOption(option)
        },
    },
}
</script>

<style lang='scss' scoped>
.box {
    width: 100%;
    height: 100%;
    // background-color: #21274d;
    .under {
        display: flex;
        justify-content: space-between;
        .left {
            flex: 1;
            .home_ul {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 24px;
                position: relative;
                .home_tb {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                }
                li {
                    flex: 1;
                    // padding: 36px 30px;
                    padding: 0 2px 2px;
                    .home_ul_main {
                        display: inline-block;
                        // cursor: pointer;
                    }
                    .home_li_tit {
                        font-size: 16px;
                        font-weight: bold;
                        color: #fff;
                        margin-bottom: 6px;
                    }
                    .home_li_num {
                        color: #fff;
                        font-size: 28px;
                        font-weight: bold;
                        span {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
        .zhanwei {
            flex: 1;
        }
        .right {
            flex: 2;
            .home_ul {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 24px;
                position: relative;
                .home_tb {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                }
                li {
                    flex: 1;
                    // padding: 36px 30px;
                    padding: 0 2px 2px;
                    .home_ul_main {
                        display: inline-block;
                        // cursor: pointer;
                    }
                    .home_li_tit {
                        font-size: 16px;
                        font-weight: bold;
                        color: #fff;
                        margin-bottom: 6px;
                    }
                    .home_li_num {
                        color: #fff;
                        font-size: 28px;
                        font-weight: bold;
                        span {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dataBoard/instrumentPanel.vue